import React from 'react';

import TrackedCompanies from '../../components/Monitoring/TrackedCompanies';

function TrackedCompaniesView() {
  return (
    <TrackedCompanies />
  );
}

export default TrackedCompaniesView;
